module.exports = __webpack_public_path__ + "static/media/vomit.b3481288.svg";